import { useCallback } from 'react';

import { profileApi } from '@pukka/api';
import auth from '@pukka/auth';
import { clickstreamTracker } from '@pukka/clickstream';
import { Image } from '@pukka/ui-components';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { FaChevronDown, FaSignOutAlt } from 'react-icons/fa';

function SidebarProfileButton() {
  const { data: profile, isLoading } = profileApi.useProfile();
  const userName = `${profile?.first_name} ${profile?.last_name}`;

  const handleClickLogout = useCallback(() => {
    clickstreamTracker.trackComponent('MOKAPOS_LOGOUT', {
      merchant: {
        userId: profile?.id,
        alreadySubscribed: profile?.already_subscribed,
        isOwner: profile?.is_owner,
        email: profile?.email,
        role: profile?.role_name,
      },
    });

    auth.logout();
  }, [profile]);

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger className="flex h-[42px] w-full items-center justify-between border-y border-legacy-800 bg-legacy-600 p-nav-item font-serif text-xs text-neutral-400">
        {isLoading ? 'Loading...' : userName}
        <span>
          <FaChevronDown />
        </span>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          data-testid="profile-dialog"
          role="dialog"
          className="z-60 -mt-6 w-full overflow-hidden rounded bg-white text-xs text-neutral-800"
        >
          <div className="flex items-start space-x-2 border-b border-neutral-300 p-2">
            <div className="relative h-10 w-3/12 bg-neutral-300">
              <Image height={40} width={40} src={profile?.gravatar} alt="User avatar" className="h-full w-full object-cover" />
            </div>
            <div className="flex w-9/12 flex-col">
              <span className="text-sm">{userName}</span>
              <span className="w-full truncate text-neutral-500">{profile?.email}</span>
            </div>
          </div>

          <button type="button" className="flex h-10 w-full items-center p-2 text-neutral-500" onClick={handleClickLogout}>
            <FaSignOutAlt className="mr-2 text-sm" />
            Sign Out
          </button>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}

export { SidebarProfileButton };
